"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageDialogButtonHandler = void 0;
exports.MessageDialog = MessageDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var message_dialog_1 = require("../../features/thunks/message-dialog");
var dialogs_1 = require("../../interfaces/dialogs");
var hooks_1 = require("../../store/hooks");
var messageDialogButtonHandler = (_a = {},
    _a[dialogs_1.EMessageDialogButtonType.OK] = function () {
        console.log("OK button clicked");
    },
    _a[dialogs_1.EMessageDialogButtonType.CANCEL] = function () {
        console.log("Cancel button clicked");
    },
    _a);
exports.messageDialogButtonHandler = messageDialogButtonHandler;
function MessageDialog() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.messageDialog; }), isOpen = _a.isOpen, header = _a.header, body = _a.body, buttons = _a.buttons;
    var dispatch = (0, hooks_1.useAppDispatch)();
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[360px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { onPress: function () {
                                dispatch((0, message_dialog_1.closeMessageDialogThunk)());
                            } }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: header !== null && header !== void 0 ? header : "No Header" }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { children: body !== null && body !== void 0 ? body : "No Body" }), buttons && buttons.length > 0 && ((0, jsx_runtime_1.jsx)(react_1.Modal.Footer, { children: buttons.map(function (button) { return ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: button.variant, className: "flex-1", onPress: function () {
                                    messageDialogButtonHandler[button.type]();
                                    dispatch((0, message_dialog_1.closeMessageDialogThunk)());
                                }, children: button.label }, button.type)); }) }))] }) }) }) }));
}
